export class DealerEntityMixSpecification {
	specification: number;
	volume: number;
	entityCode: string;
}
